<template>
  <div class="faqs">
    <Banner
      :title="'FREQUENTLY ASKED QUESTIONS'"
      :class-banner="'common-banner'"
    />
    <div
      v-for="(item, index) in listQuestions"
      :key="index"
      class="faqs__questions"
    >
      <div
        @click="handleToggleAnswer(index)"
        class="faqs__questions-question"
      >
        {{ item.question }}
        <img
          v-if="item.isActive"
          class="tabs-swift__title-icon-down"
          src="@/assets/images/account/toggle-close.png"
        />
        <img
          v-if="!item.isActive"
          class="tabs-swift__title-icon-up"
          src="@/assets/images/account/toggle-open.png"
        />
      </div>
      <div v-if="item.isActive" class="faqs__questions-answer">{{ item.answer }}</div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/common/banner';
export default {
  components: {
    Banner
  },
  data () {
    return {
      listQuestions: [
        {
          question: 'What is Loterie Vert?',
          answer: 'Lottery Vert is an online game in which players select seven (7) numbers from 1 to 28 inclusive',
          isActive: false
        },
        {
          question: 'How much is a Loterie Vert ticket?',
          answer: 'The price of a single grid is Rs30',
          isActive: false
        },
        {
          question: 'When are the Loterie Vert draws?',
          answer: 'Draw time Every Friday at 20h25',
          isActive: false
        },
        {
          question: 'Where can I watch the Loterie Vert draws live?',
          answer: 'Draw time Every Friday on TV MCB01 at 20h25',
          isActive: false
        },
        {
          question: "Ways to play Loterie Vert:",
          answer: 'In Store\n' +
              'Or \n' +
              'Online',
          isActive: false
        },
        {
          question: "What are the playing Options:",
          answer: '- Online:\n' +
              'Choose your own Numbers\n' +
              'Quick Pick Number\n' +
              '- In Store:\n' +
              'Choose your own Numbers\n' +
              'Quick Pick Numbers\n' +
              'Combine Numbers\n' +
              'Super Quick Pick\n',
          isActive: false
        },
        {
          question: 'What is the earnings structure?',
          answer: 'Price Pool Table Here',
          isActive: false
        },
        {
          question: 'Does the \'rolldown\' principle still apply?',
          answer: 'Yes if there is no winner from a current draw, the amount is added to the next category.',
          isActive: false
        },
        {
          question: 'What is the jackpot to carry forward?',
          answer: 'The roll over system applies to the jackpot when it is not won. If there is a winner, the jackpot will be announced during the draws.',
          isActive: false
        },
        {
          question: 'At what time is the game closing?',
          answer: 'The game will close at 7 p.m. every Friday.',
          isActive: false
        },
        {
          question: 'What happens if there is no jackpot winner?',
          answer: 'The amount of the unsuccessful jackpot is added to the jackpot for the next draw: \'rollover\'.',
          isActive: false
        },
        {
          question: 'Can I play for a long time and reserve my numbers in advance?',
          answer: 'You can play for a maximum of 6 draws. Please note that numbers cannot be reserved in advance.',
          isActive: false
        },
        {
          question: 'Where can I consult the rules of the game?',
          answer: 'The rules of the game are posted at all our retailers. You can also consult the website of the Loterie Vert: www.loterievert.mu',
          isActive: false
        },
        {
          question: 'Where can I claim my prize?',
          answer: 'Please present your ticket to an official Lottotech retailer for all lots less than Rs 2,000.\n' +
              'For amounts over Rs 2,000, please visit an authorized retailer or Lottotech head office. You must bring your national identity card or a valid and valid passport.',
          isActive: false
        },
        {
          question: 'What should I do if I win the jackpot?',
          answer: 'Congratulations ! To claim the jackpot, you will need to go to Lottotech\'s head office with your identity card.\n' +
              'Our team will explain the procedures to you and make verifications as specified in the payment procedure validated by the GRA.\n',
          isActive: false
        },
        {
          question: 'What documents will I need to bring when claiming the jackpot?',
          answer: 'Congratulations ! To claim the jackpot, you will need to go to Lottotech\'s head office with your identity card.',
          isActive: false
        },
        {
          question: 'If I win can I remain anonymous?',
          answer: 'Obviously, the winners have the right to remain anonymous.',
          isActive: false
        },
        {
          question: 'If there are several first prize winners, how is the prize distributed?',
          answer: 'The prize will be divided into equal amounts among the winners.',
          isActive: false
        },
        {
          question: 'What happens to unclaimed prizes?',
          answer: 'All unclaimed prizes are donated to the National Solidarity Fund under the aegis of the Ministry of Social Integration.',
          isActive: false
        },
        {
          question: 'How long do I have to claim my prize?',
          answer: 'You have six months from the date of the draw to come and claim your prize.',
          isActive: false
        },
        {
          question: 'When paying the receipts to the bank, do I have to balance my account myself or will you give me the adjusted amount?',
          answer: 'The amount will be automatically adjusted. You will therefore have the exact amount to transfer to the bank on your online invoice on the terminal.',
          isActive: false
        }
      ]
    }
  },
  methods: {
    handleToggleAnswer(index) {
      this.listQuestions.forEach((item, i) => {
        if (i === index) {
          item.isActive = !item.isActive;
        }
      })
    }
  }
}
</script>
